import React, { useState } from "react"
import { NavLink } from "react-router-dom"
import funArray from "../404fun"
import "./styles/notFound.css"

export default function NotFound(props) {
    const [isRevealed, setIsRevealed] = useState(false)
    const jokeOrRiddle = useState(funArray[Math.floor(Math.random()*funArray.length)])
    let emojis = ["😆", "🤣", "😂", "😀", "😅", "😃", "😄", "😁", "🤪", "😜", "😝", "😛", "🤑", "🤠", "🤩", "😺", "😸", "😹", "😻", "👅", "👻"]
    const randomEmoji = useState(emojis[Math.floor(Math.random()*emojis.length)])
    let FunType
    let funType
    let funTypeResult
    if(jokeOrRiddle[0].joke.setup === "") {
        FunType = "Riddle"
        funType = "Riddle"
        funTypeResult = "Answer"
    } else {
        FunType = "Joke"
        funType = "Setup"
        funTypeResult = "Punchline"
    }

    return(
        <div className="errorPageContainer">
            <h1>Oops, seems like an error occured!!</h1>
            <h2>404 page not found</h2>
            <h2>Didn't expect this to happen? No worries, You can get back to the page where you were before :</h2>
            {/*linksToPages*/}
            <div className="errorPageNavlinkscontainer">
                <NavLink className="errorPageNavlinks" to="/">Home</NavLink>
                <NavLink className="errorPageNavlinks" to="products">Products</NavLink>
                <NavLink className="errorPageNavlinks" to="blog">Blog</NavLink>
                <NavLink className="errorPageNavlinks" to="about">About</NavLink>
                <NavLink className="errorPageNavlinks" to="contacts">Contacts</NavLink>
            </div>    
            <h2>In need of some humour? Here you Go</h2>
            <h2>{(FunType === "Joke" ? FunType + ": " : "")}{funType}: {funType === "Riddle" ? jokeOrRiddle[0].riddle.question : jokeOrRiddle[0].joke.setup}</h2>
            {isRevealed && <h2 id="answerOrPunchlineTextInErrorPage">{funTypeResult}: {funType === "Riddle" ? jokeOrRiddle[0].riddle.answer : jokeOrRiddle[0].joke.punchline}{randomEmoji}</h2>}
            <button onClick={() => {setIsRevealed(!isRevealed)}} className="revealHumourErrorPage">{isRevealed ? "Hide" : "Show"} {isRevealed ?  funTypeResult : funTypeResult}</button>
        </div>
            
    )
}